import { render, staticRenderFns } from "./cabinetCell.vue?vue&type=template&id=3e72cebe&scoped=true&"
import script from "./cabinetCell.vue?vue&type=script&lang=js&"
export * from "./cabinetCell.vue?vue&type=script&lang=js&"
import style0 from "./cabinetCell.vue?vue&type=style&index=0&id=3e72cebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72cebe",
  null
  
)

export default component.exports